import { useFlag } from '@/features/unleash';
import { WatchlistItem } from '@/hooks/useWatchlist';

type Props = {
  watchlistItem: WatchlistItem;
};

export const useWatchlistNarrativeFairValue = ({ watchlistItem }: Props) => {
  const { flagsReady, enabled } = useFlag({
    name: 'mono-narrative-valuation-options-migration',
  });

  // Future data source - myValuation
  if (flagsReady && enabled) {
    return {
      fairValue: watchlistItem.company.myValuation?.fairValue ?? null,
      valuationId: watchlistItem.company.myValuation?.id ?? null,
      narrativeId: watchlistItem.company.myValuation?.narrative?.id,
      type: watchlistItem.company.myValuation?.type ?? null,
    };
  }

  // Legacy data source - narrativeFairValue
  return {
    fairValue:
      watchlistItem.narrativeFairValue.valuationId !== null
        ? watchlistItem.narrativeFairValue.fairValue
        : watchlistItem.fairValue,
    valuationId: watchlistItem.narrativeFairValue.valuationId ?? null,
    narrativeId: watchlistItem.narrativeFairValue.narrativeId,
    type: watchlistItem.narrativeFairValue.type ?? null,
  };
};
